import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { MessageListItem } from "~/src/components/messages";

const useStyles = makeStyles((theme) => ({
  list: {
    display: "flex",
    flexDirection: "column",
    margin: 0,
    padding: 0,
  },
  item: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
    listStyle: "none",
    marginBottom: theme.spacing(2),
  },
}));

export default function MessageList(props) {
  const {
    messages, authUser, self, otherName,
  } = props;
  const classes = useStyles();

  return (
    <ul className={classes.list}>
      {messages
        && [].concat(messages)
          .sort((a, b) => {
            if (!a.timestamp) return 1;
            if (!b.timestamp) return -1;
            return a.timestamp.seconds - b.timestamp.seconds;
          })
          .map((messageItem, index) => (
          <li key={index} className={classes.item}>
            <MessageListItem
              authUser={authUser}
              self={self}
              data={messageItem}
              otherName={otherName}
            />
          </li>
          ))}
    </ul>
  );
}
